export { BootstrapScreen } from "./BootstrapScreen"

import NProgress from "nprogress"
import { validateEnv } from "@/shared/config/env"
import { initI18n } from "@/shared/i18n"
import axiosInstance from "@/shared/api/axios"
import { initMockServer } from "@/processes/mock-server"
import { createRouter, setInitialRoute } from "../router"
import { setBootstrapError } from "./bootstrap-error"

NProgress.configure({
  showSpinner: false,
  trickleSpeed: 200,
  trickleRate: 0.05,
} as unknown as NProgress.NProgressOptions)

export async function bootstrap() {
  try {
    validateEnv()

    await initI18n()

    initMockServer(axiosInstance)

    setInitialRoute()
  } catch (error) {
    console.error("Error while initializing the app", error)

    setBootstrapError(error)
    setInitialRoute({ error })
  }

  const router = createRouter()

  return { router }
}
